import omniSearchService from 'src/store/modules/omni/omniSearchService/reducers';
import * as omniSearchServiceOperation from 'src/store/modules/omni/omniSearchService/operations';

export { omniSearchServiceOperation };

export default omniSearchService;
